export default "1a5eb80b03f779ad.svg"